export var STATUS_TYPE = {
  WARNING: 'warning',
  ERROR: 'error',
  SUCCESS: 'success'
};
//# sourceMappingURL=constants.js.map